<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">离职交接</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
		  <quit v-if="activeIndex=='list'"></quit>
      </div>
    </div>
  </div>
</template>

<script>
import quit from './quit.vue';//发票类型
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
	  restId:null,
    };
  },
  components: {
	quit,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath){
	  console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>